import { changeStatusShortLink } from "../api/shortlinksReportsApi";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { SuccessMessage, ErrorMessage } from "../../../utils/toastify";

export const useChangeStatusShortLink = (refetch = () => {}) => {
  const auth = useAuth();
  const { token, uid_partner } = auth.getSessionData();

  return useMutation({
    mutationFn: async ({ idRecordToInactivate }) => {
      return changeStatusShortLink({
        token,
        uid_partner,
        idRecordToInactivate,
      });
    },
    onSuccess: (data) => {
      if (data?.error) {
        ErrorMessage("Error al cambiar el estado");
        return;
      }

      refetch();
      SuccessMessage("Se ha cambiado el estado");
    },
    onError: () => {
      ErrorMessage("Error al cambiar el estado");
    },
  });
};
